/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { CancelablePromise, CancelError } from './core/CancelablePromise';
export { OpenAPI } from './core/OpenAPI';
export type { OpenAPIConfig } from './core/OpenAPI';

export type { ActionBy } from './models/ActionBy';
export { ActivityCategories } from './models/ActivityCategories';
export { AdminLeadStatus } from './models/AdminLeadStatus';
export { ApplicationRole } from './models/ApplicationRole';
export type { ArchiveInBulkRequest } from './models/ArchiveInBulkRequest';
export type { ArchiveInBulkFailure, ArchiveInBulkResponse } from './models/ArchiveInBulkResponse';
export type { ArchiveRequest } from './models/ArchiveRequest';
export type { AssignTaskRequest } from './models/AssignTaskRequest';
export { AttorneyApprovalStatus } from './models/AttorneyApprovalStatus';
export type { AttorneyLeadsResponse } from './models/AttorneyLeadsResponse';
export { AttorneyLeadStatus } from './models/AttorneyLeadStatus';
export { AttorneyStatus } from './models/AttorneyStatus';
export type { AuthResponse } from './models/AuthResponse';
export type { CalendarEventViewModel } from './models/CalendarEventViewModel';
export { Category } from './models/Category';
export type { ClassViewModel } from './models/ClassViewModel';
export type { ClientRepresentationRequest } from './models/ClientRepresentationRequest';
export type { ClientSearchRequest } from './models/ClientSearchRequest';
export type { ClioTasksInfo } from './models/ClioTasksInfo';
export type { CommentViewModel } from './models/CommentViewModel';
export type { ContactAddress } from './models/ContactAddress';
export type { ContactData } from './models/ContactData';
export type { ContactEmail } from './models/ContactEmail';
export type { ContactPhone } from './models/ContactPhone';
export { ContactReason } from './models/ContactReason';
export type { CreatedBy } from './models/CreatedBy';
export { CSAType } from './models/CSAType';
export { CustomFields } from './models/CustomFields';
export type { Data } from './models/Data';
export { DeclinedAction } from './models/DeclinedAction';
export type { DeleteRequest } from './models/DeleteRequest';
export { EdmContainerElementKind } from './models/EdmContainerElementKind';
export { EdmExpressionKind } from './models/EdmExpressionKind';
export { EdmSchemaElementKind } from './models/EdmSchemaElementKind';
export { EdmTypeKind } from './models/EdmTypeKind';
export { EmployedTimeType } from './models/EmployedTimeType';
export { EmployeePaidType } from './models/EmployeePaidType';
export { EmployeePunishment } from './models/EmployeePunishment';
export type { EmploymentViewModel } from './models/EmploymentViewModel';
export type { EntryDayGrouping } from './models/EntryDayGrouping';
export { EntryType } from './models/EntryType';
export type { ExtensionDetails } from './models/ExtensionDetails';
export type { ExtensionsTableRequest } from './models/ExtensionsTableRequest';
export { FileType } from './models/FileType';
export type { FileViewModel } from './models/FileViewModel';
export type { GetLeadsByIdsRequest } from './models/GetLeadsByIdsRequest';
export type { GetUserListRequest } from './models/GetUserListRequest';
export type { GrandTotal } from './models/GrandTotal';
export { HarassmentCategory } from './models/HarassmentCategory';
export type { HubspotWebhookResponse } from './models/HubspotWebhookResponse';
export { HurtType } from './models/HurtType';
export type { IEdmDirectValueAnnotationsManager } from './models/IEdmDirectValueAnnotationsManager';
export type { IEdmEntityContainer } from './models/IEdmEntityContainer';
export type { IEdmEntityContainerElement } from './models/IEdmEntityContainerElement';
export type { IEdmExpression } from './models/IEdmExpression';
export type { IEdmModel } from './models/IEdmModel';
export type { IEdmSchemaElement } from './models/IEdmSchemaElement';
export type { IEdmTerm } from './models/IEdmTerm';
export type { IEdmType } from './models/IEdmType';
export type { IEdmTypeReference } from './models/IEdmTypeReference';
export type { IEdmVocabularyAnnotatable } from './models/IEdmVocabularyAnnotatable';
export type { IEdmVocabularyAnnotation } from './models/IEdmVocabularyAnnotation';
export type { InitialClientDataResponse } from './models/InitialClientDataResponse';
export { Injuries } from './models/Injuries';
export { InjuryType } from './models/InjuryType';
export type { IntentResponse } from './models/IntentResponse';
export type { LeadAttorneysResponse } from './models/LeadAttorneysResponse';
export type { LeadCommentRequest } from './models/LeadCommentRequest';
export type { LeadReportData } from './models/LeadReportData';
export type { LeadsDateReport } from './models/LeadsDateReport';
export type { LeadShareRequest } from './models/LeadShareRequest';
export type { LeadShortResponse } from './models/LeadShortResponse';
export type { LeadsPracticeGrouping } from './models/LeadsPracticeGrouping';
export type { LeadsReport } from './models/LeadsReport';
export type { LeadsStatusGrouping } from './models/LeadsStatusGrouping';
export type { LeadSummary } from './models/LeadSummary';
export type { LeadsUserReport } from './models/LeadsUserReport';
export { LeadTableType } from './models/LeadTableType';
export type { LeadViewModel } from './models/LeadViewModel';
export type { LeadWinnerRequest } from './models/LeadWinnerRequest';
export type { LoginExternalRequest } from './models/LoginExternalRequest';
export type { LoginRequest } from './models/LoginRequest';
export { LoginType } from './models/LoginType';
export type { FilingReportDownloadRequest } from './models/FilingReportDownloadRequest';
export type { FilingReportStatusEntry } from './models/FilingReportStatusEntry';
export type { FilingReportItem } from './models/FilingReportItem';
export type { LloFunnelReportItem } from './models/LloFunnelReportItem';
export type { LloFunnelReportRequest } from './models/LloFunnelReportRequest';
export type { FilingReportStatusRequest } from './models/FilingReportStatusRequest';
export type { MatterPreviewResponse } from './models/MatterPreviewResponse';
export type { ManualTaskAssignmentReportItem } from './models/ManualTaskAssignmentReportItem';
export type { NetDocsMatterResponse } from './models/NetDocsMatterResponse';
export type { ODataEntitySetInfo } from './models/ODataEntitySetInfo';
export type { ODataFunctionImportInfo } from './models/ODataFunctionImportInfo';
export type { ODataServiceDocument } from './models/ODataServiceDocument';
export type { ODataSingletonInfo } from './models/ODataSingletonInfo';
export type { ODataTypeAnnotation } from './models/ODataTypeAnnotation';
export { PaidType } from './models/PaidType';
export { PaidWithheld } from './models/PaidWithheld';
export type { PandaWebhookData } from './models/PandaWebhookData';
export { Path } from './models/Path';
export type { PersonalInjuryViewModel } from './models/PersonalInjuryViewModel';
export { ProtectedCategory } from './models/ProtectedCategory';
export { RadioOptions } from './models/RadioOptions';
export { ReasonForDecline } from './models/ReasonForDecline';
export { ReasonForDeclinePI } from './models/ReasonForDeclinePI';
export { ReasonForKeepPI } from './models/ReasonForKeepPI';
export { ReasonForNAEmp } from './models/ReasonForNAEmp';
export { ReasonForNAPI } from './models/ReasonForNAPI';
export { ReasonForNgcWC } from './models/ReasonForNgcWC';
export { ReasonForReferPI } from './models/ReasonForReferPI';
export type { Recipient } from './models/Recipient';
export type { RegisterLinkRequest } from './models/RegisterLinkRequest';
export type { ReportLevel2 } from './models/ReportLevel2';
export type { ReportLevel3 } from './models/ReportLevel3';
export type { ReportLevel4 } from './models/ReportLevel4';
export type { ReportLevel5 } from './models/ReportLevel5';
export type { ReportModel } from './models/ReportModel';
export type { ReportRequest } from './models/ReportRequest';
export { ReportTypes } from './models/ReportTypes';
export type { ResetPasswordRequest } from './models/ResetPasswordRequest';
export type { SendLeadRequest } from './models/SendLeadRequest';
export type { SentBy } from './models/SentBy';
export type { StatusUpdateRequest } from './models/StatusUpdateRequest';
export type { ReferralCaseProgressViewModel } from './models/ReferralCaseProgressViewModel';
export type { SupplementalViewModel } from './models/SupplementalViewModel';
export type { TableExtensionsResponse } from './models/TableExtensionsResponse';
export type { TableFilter } from './models/TableFilter';
export type { TableLeadsRequest } from './models/TableLeadsRequest';
export type { TableLeadsResponse } from './models/TableLeadsResponse';
export type { TaskExtensionActionViewModel } from './models/TaskExtensionActionViewModel';
export type { TaskExtensionBulkRequest } from './models/TaskExtensionBulkRequest';
export type { TaskExtensionViewModel } from './models/TaskExtensionViewModel';
export { TaskExtentionStatus } from './models/TaskExtentionStatus';
export type { TaskPreviewResponse } from './models/TaskPreviewResponse';
export { TaskTypes } from './models/TaskTypes';
export type { Template } from './models/Template';
export { TerminationType } from './models/TerminationType';
export type { TimeEntryReportModel } from './models/TimeEntryReportModel';
export type { TimeEntryViewModel } from './models/TimeEntryViewModel';
export type { TimeKeepingReport } from './models/TimeKeepingReport';
export type { UpdateApprovalStatusRequest } from './models/UpdateApprovalStatusRequest';
export type { UserCreateRequest } from './models/UserCreateRequest';
export type { UserEducationViewModel } from './models/UserEducationViewModel';
export type { UserNotificationResponse } from './models/UserNotificationResponse';
export type { UserPushIdRequest } from './models/UserPushIdRequest';
export type { UserShortResponse } from './models/UserShortResponse';
export type { UsersModel } from './models/UsersModel';
export type { UserViewModel } from './models/UserViewModel';
export { VehicleType } from './models/VehicleType';
export type { WitnessViewModel } from './models/WitnessViewModel';
export type { WorkersCompViewModel } from './models/WorkersCompViewModel';
export type { ZoomCommunicationViewModel } from './models/ZoomCommunicationViewModel';
export type { ZoomSetMatterRequest } from './models/ZoomSetMatterRequest';
export type { ZoomTableRequest } from './models/ZoomTableRequest';
export type { ZoomTableResponse } from './models/ZoomTableResponse';
export type { ZoomUserResponse } from './models/ZoomUserResponse';

export { ClioService } from './services/ClioService';
export { ExtensionsService } from './services/ExtensionsService';
export { FileService } from './services/FileService';
export { HubspotService } from './services/HubspotService';
export { LeadsService } from './services/LeadsService';
export { MetadataService } from './services/MetadataService';
export { NetDocsService } from './services/NetDocsService';
export { PandaService } from './services/PandaService';
export { PaymentsService } from './services/PaymentsService';
export { PingService } from './services/PingService';
export { UsersService } from './services/UsersService';
export { ZoomService } from './services/ZoomService';
export { RingCentralService } from './services/RingCentralService';
